import React, { FC } from 'react';

import { useHistory } from 'react-router';

import TotalDropDown from '../../shop/selectionlists/TotalDropDown';
import TotalAmountBadges from '../common/TotalAmountBadges';
import { Orderlist } from '../../../models/OrderList';
import { SpocState } from '../../store/authentication/state';
import SubNavigationLayout from './SubNavigationLayout';

import './SelectionListNavigation.scss';
import { useTranslation } from 'react-i18next';

type Props = {
    readonly hide?: boolean;
    readonly activeList: Orderlist | undefined;
    readonly spoc?: SpocState;
    readonly isSticky?: boolean;
};

const SelectionListNavigation: FC<Props> = ({ hide = false, isSticky, activeList, ...props }) => {
    const { t } = useTranslation();
    const { goBack } = useHistory();

    if (hide) {
        return null;
    }

    return (
        <SubNavigationLayout
            className="selection-list-nav"
            isSticky={isSticky}
            left={
                <ul className="selection-list-nav-left">
                    {!isSticky && (
                        <li>
                            <a onClick={goBack} className="back">
                                <i className="material-icons big">arrow_back</i>
                            </a>
                        </li>
                    )}
                    <li>
                        <span>Selection List</span>
                    </li>
                    <li>
                        <i className="material-icons big">keyboard_arrow_right</i>
                    </li>
                    <li>
                        <span>{activeList?.listName}</span>
                    </li>
                </ul>
            }
            right={
                isSticky && (
                    <div className="selection-list-nav-right">
                        <TotalAmountBadges {...activeList} className="display-flex" />
                        <TotalDropDown {...props} textTotalLine={t('components.totalDropdown.listTotal')} />
                    </div>
                )
            }
        />
    );
};

export default SelectionListNavigation;
